import Cookies from "js-cookie";
import React, { FunctionComponent, useCallback } from "react";
import ClickableDiv from "../shared/ClickableDiv";
import { navigate } from "@reach/router";

interface IProps {
	children: React.ReactNode;
	className?: string;
	tabIndex?: number;
	reload(loggedOut?: boolean): void;
	onKeyDown?(event: KeyboardEvent): void;
}

const LogoutButton: FunctionComponent<IProps> = (props) => {
	const { children, className, tabIndex, onKeyDown, reload } = props;

	const onClick = useCallback(() => {
		Cookies.remove("xsrf_token");
		Cookies.remove("access_token");
		navigate("/").then(() => window.location.reload());
		reload(true);
	}, [reload]);

	return <ClickableDiv className={className} title="Logout" tabIndex={tabIndex} onKeyDown={onKeyDown} onClick={onClick}>
		{children}
	</ClickableDiv>;
}

export default LogoutButton;